import {Component, input} from "@angular/core";
import {MatIcon} from "@angular/material/icon";
import {TranslateModule} from "@ngx-translate/core";
import {Translations} from "@translations";
import {SessionState} from "@models";
import {NgTemplateOutlet} from "@angular/common";
import {SimStatusPalette} from "src/app/shared/models/SimStatusPalette";

@Component({
	selector: "sim-session-status-tag",
	standalone: true,
	imports: [MatIcon, TranslateModule, NgTemplateOutlet],
	templateUrl: "./session-status-tag.component.html",
	styleUrl: "./session-status-tag.component.scss",
})
export class SessionStatusTagComponent {
	// Inputs
	public status = input.required<SessionState>();
	public isValid = input<boolean>(true);

	// Constants
	protected readonly T = Translations;
	protected readonly SessionState = SessionState;
	protected readonly SimStatusPalette = SimStatusPalette;
}
